var React = require('react');

function Link (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11.6288 8.78647C11.9503 8.9696 12.2518 9.19956 12.5261 9.47389C14.1742 11.1219 14.2193 13.7489 12.1459 15.8222L9.33789 18.6303C7.26449 20.7037 4.63758 20.6585 2.98953 19.0105C1.34149 17.3624 1.29633 14.7355 3.36969 12.6621L5.41406 10.6094","stroke":"white","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M10.3713 13.2134C10.0497 13.0303 9.74826 12.8003 9.47389 12.526C7.82584 10.8779 7.78072 8.251 9.85408 6.17764L12.6621 3.36959C14.7355 1.29619 17.3624 1.34135 19.0105 2.98939C20.6585 4.63748 20.7037 7.26436 18.6303 9.33771L16.586 11.3905","stroke":"white","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Link.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = Link;

Link.default = Link;
